module.exports = __webpack_public_path__ + "media/images/europe-62d111002f896cb125027c53308d2df6.png";